import { useState } from "react";

const faqs = [
  {
    q: "漫画岛支持哪些阅读模式?",
    a: "漫画岛支持滚动阅读、翻页阅读和双页横屏三种主要阅读模式,你可以在阅读页面随时切换,找到最适合自己的追漫方式。",
  },
  {
    q: "如何开启横屏观看高清原图?",
    a: "在漫画详情页点击「开始阅读」进入阅读界面,然后旋转你的设备至横屏,即可自动切换到横屏高清模式,放大呈现每一格画面细节。",
  },
  {
    q: "夜间模式在哪里设置?",
    a: "点击页面右上角的月亮图标即可一键切换夜间模式。开启后阅读界面会使用深色背景与低蓝光设计,夜间追漫更护眼、不累眼。",
  },
  {
    q: "长时间追漫会累眼吗?",
    a: "漫画岛通过夜间模式、舒适的翻页动效和可调节的文字与画面设置,尽可能减少长时间阅读带来的视觉疲劳,让你享受每一格画面。",
  },
  {
    q: "漫画内容是否需要付费?",
    a: "本平台提供部分免费试看内容供读者体验。本平台内容仅供学习交流使用,请支持正版漫画,尊重每一位作者的创作。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-background-100">
      <div className="container-site grid gap-10 py-16 md:grid-cols-5 md:py-20">
        <div className="md:col-span-2">
          <p className="inline-flex items-center gap-2 text-xs font-medium text-accent-600">
            <i className="ri-questionnaire-fill"></i>
            常见问题
          </p>
          <h2 className="mt-2 text-2xl font-semibold text-foreground-950 md:text-3xl">
            关于阅读体验,你想知道的
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            这里整理了读者最常询问的问题。如果还有其他疑问,欢迎通过关于我们页面的联系方式与我们沟通。
          </p>
        </div>

        <div className="flex flex-col gap-3 md:col-span-3">
          {faqs.map((item, idx) => (
            <div
              key={item.q}
              className="overflow-hidden rounded-lg bg-background-50 transition-colors hover:bg-background-200/70"
            >
              <button
                type="button"
                onClick={() => setOpen(open === idx ? -1 : idx)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                aria-expanded={open === idx}
              >
                <span className="text-sm font-semibold text-foreground-950 md:text-base">
                  {item.q}
                </span>
                <i
                  className={`ri-add-line shrink-0 text-lg text-primary-500 transition-transform ${
                    open === idx ? "rotate-45" : ""
                  }`}
                ></i>
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  open === idx ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}